<template>
    <div class="crumbs-note">
        <a class="crumbs-note__link" target="_blank" rel="noopener sponsored"
            v-bind:href="$t(`ads.${campaign}.link`)">
            <span class="crumbs-note__emoji">{{ EMOJI[campaign] }}</span>
            <span class="crumbs-note__text">
                <template v-if="$te(`ads.${campaign}.breadcrumbs_note.before`)">
                    {{ $t(`ads.${campaign}.breadcrumbs_note.before`) }}
                </template>
                <span class="crumbs-note__accent">{{ $t(`ads.${campaign}.breadcrumbs_note.accent`) }}</span>
                {{ $t(`ads.${campaign}.breadcrumbs_note.after`) }}
            </span>
        </a>
    </div>
</template>

<script>
import { isRussianSpeaker } from './audience.js';

const EMOJI = {
    gramvpn: '🎁',
    stakee: '💎',
};

export default {
    computed: {
        EMOJI() {
            return EMOJI;
        },
        // Same audience split as the homepage banner:
        campaign() {
            return isRussianSpeaker(this.$i18n.locale) ? 'gramvpn' : 'stakee';
        },
    },
};
</script>

<style lang="scss">
// Plain text on the right of the breadcrumbs, set like the crumbs themselves.
// Zero flex-basis: it only ever gets the space the trail leaves free and never
// takes any from it. When that space runs short, the text is cut from the end
// first, then the whole line goes.
.crumbs-note {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    justify-content: flex-end;
    container-type: inline-size;

    // The air after the trail sits on the link, not on the box: once the link
    // is gone the box is zero wide and the trail has the whole row again.
    &__link {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        min-width: 0;
        max-width: calc(100% - 24px);
        margin-left: 24px;
        color: var(--breadcrumbs-text-color);
        text-decoration: none !important;
        transition: color .15s ease;

        &:hover {
            color: var(--body-text-color);
        }
        &:focus-visible {
            outline: 2px solid var(--blue-bright);
            outline-offset: 2px;
            border-radius: 4px;
        }
    }

    &__emoji {
        flex-shrink: 0;
    }

    &__text {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__accent {
        color: var(--blue-bright);
    }
}

// Cut down to a couple of words, the line says nothing (24px of it is the margin):
@container (max-width: 184px) {
    .crumbs-note__link {
        display: none;
    }
}

// Phones and narrow tablets: no line at all.
@media screen and (max-width: 880px) {
    .crumbs-note {
        display: none;
    }
}
</style>
